export const invoiceStatementInitialValues = {
  type_of_view: '',
  emailAddress: '',
  fromDate: null,
  toDate: null,
  savedDataFields: null,
  dataFields: null,
};

export const dataFieldsinitialValues = {
  invoiceDetails: [
    'E_INVOICE_NUMBER',
    'E_INVOICE_TYPE',
    'E_INVOICE_TRANSACTION_TYPE',
  ],
  currencyDetails: ['INVOICE_CURRENCY'],
  sellerDetails: [],
  buyerDetails: ['BUYER_NAME', 'BUYER_VAT_ACCOUNT_NUMBER'],
  thirdPartyDetails: [],
  amounts: [],
  amountsLocal: [],
  supplies: [],
};
